import { useTranslation } from 'react-i18next';

/** A link item's address, right under the summary in the editors. */
export const EXTERNAL_URL = /^https?:\/\/\S+$/i;

function ArticleLinkField({ id, value, onChange, disabled = false }) {
  const { t } = useTranslation();

  return (
    <div className="account-field-row">
      <label htmlFor={id}>
        {t('articleLink.label')}
      </label>

      <input
        id={id}
        type="url"
        inputMode="url"
        autoComplete="url"
        maxLength={2000}
        value={value ?? ''}
        disabled={disabled}
        placeholder="https://"
        onChange={(event) => onChange(event.target.value.trim())}
      />
    </div>
  );
}

export default ArticleLinkField;
